// newsletter-footer.js
(function () {
    const COMMON_DOMAINS_FOOTER = [
        "gmail.com", "googlemail.com", "yahoo.com", "hotmail.com",
        "outlook.com", "icloud.com", "bellsouth.net", "ymail.com",
        "aol.com", "mail.com", "protonmail.com", "zoho.com",
        "gmx.com", "live.co.uk", "hotmail.co.uk", "hotmail.fr",
        "hotmail.de", "hotmail.it", "hotmail.es", "hotmail.com.au",
        "hotmail.ca"
    ];

    //console.log('Script started');

    // Levenshtein Distance Function
    function levenshteinDistance(a, b) {
        const matrix = [];

        for (let i = 0; i <= b.length; i++) {
            matrix[i] = [i];
        }

        for (let j = 0; j <= a.length; j++) {
            matrix[0][j] = j;
        }

        for (let i = 1; i <= b.length; i++) {
            for (let j = 1; j <= a.length; j++) {
                if (b.charAt(i - 1) === a.charAt(j - 1)) {
                    matrix[i][j] = matrix[i - 1][j - 1];
                } else {
                    matrix[i][j] = Math.min(
                        matrix[i - 1][j - 1] + 1, // substitution
                        matrix[i][j - 1] + 1,     // insertion
                        matrix[i - 1][j] + 1      // deletion
                    );
                }
            }
        }

        return matrix[b.length][a.length];
    }

    // Function to suggest the closest domain
    function suggestDomain(domain) {
        console.log('Suggesting domain for:', domain);
        let bestMatch = null;
        let smallestDistance = Infinity;

        for (let commonDomain of COMMON_DOMAINS_FOOTER) {
            const distance = levenshteinDistance(domain, commonDomain);
            if (distance < smallestDistance) {
                smallestDistance = distance;
                bestMatch = commonDomain;
            }
        }

        const maxAllowedDistance = Math.max(2, Math.floor(domain.length * 0.3));

        if (smallestDistance <= maxAllowedDistance && bestMatch !== domain) {
            //console.log('Suggested domain:', bestMatch, 'with distance:', smallestDistance);
            return bestMatch;
        }

        //console.log('No suggestion found');
        return null;
    }

    // Email Validation Function
    function validateEmail(email) {
        //console.log('Validating email:', email);
        if (email.trim() === '') {
            // Empty email is considered valid here; handle empty field on form submission
            return { isValid: true };
        }

        const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        if (!regex.test(email)) {
            //console.log('Email failed regex check');
            return { isValid: false, message: 'Please enter a valid email address.' };
        }

        const [localPart, domain] = email.split('@');
        const suggestedDomain = suggestDomain(domain.toLowerCase());

        if (suggestedDomain && suggestedDomain !== domain.toLowerCase()) {
            //console.log('Typo detected. Suggested domain:', suggestedDomain);
            return {
                isValid: false,
                message: `Did you mean ${suggestedDomain}?`,
                suggestedDomain: suggestedDomain,
                originalEmail: email,
            };
        }

        //console.log('Email is valid');
        return { isValid: true };
    }

    // Function to show error message with suggestion
    function showErrorMessage(emailField, message, suggestedEmail) {
        let errorSpan = document.querySelector('.form-error-message');
        if (!errorSpan) {
            errorSpan = document.createElement('span');
            errorSpan.className = 'form-error-message';
            errorSpan.style.display = 'block';
            emailField.parentNode.insertBefore(errorSpan, emailField.nextSibling);
        }

        // Clear previous content
        errorSpan.innerHTML = '';

        if (suggestedEmail) {
            const button = document.createElement('button');
            button.textContent = suggestedEmail.split('@')[1];
            button.classList.add('suggested-email');
            button.type = 'button';
            button.setAttribute('aria-label', 'Use suggested email');

            errorSpan.appendChild(document.createTextNode('Did you mean '));
            errorSpan.appendChild(button);
            errorSpan.appendChild(document.createTextNode('?'));

            button.onclick = function () {
                if (suggestedEmail) {
                    emailField.value = suggestedEmail;
                    clearErrorMessage();
                }
            };
        } else {
            errorSpan.textContent = message;
        }

        // Add the hidden class initially
       // errorSpan.classList.add('hidden-error-message');

        // Remove the hidden class after a short delay
        setTimeout(() => {
            errorSpan.classList.add('show-new-error-message');
        }, 300);
    }

    // Function to clear the error message
    function clearErrorMessage() {
        const errorSpan = document.querySelector('.form-error-message');
        if (errorSpan) {
            // Add the hidden class
            errorSpan.classList.remove('show-new-error-message');

            // Remove the error message from the DOM after a delay
            setTimeout(() => {
                errorSpan.remove();
            }, 1000);
        }
    }

    // Debounce function
    function debounce(func, delay) {
        let debounceTimer;
        return function () {
            const context = this;
            const args = arguments;
            clearTimeout(debounceTimer);
            debounceTimer = setTimeout(() => func.apply(context, args), delay);
        };
    }

    // Debounced Email Validation Handler
    const debouncedValidateEmail = debounce(function () {
        const emailField = this;
        const email = emailField.value;

        // Only validate if the email field is not empty
        if (email.trim() === '') {
            clearErrorMessage();
            return;
        }

        const emailValidation = validateEmail(email);

        if (!emailValidation.isValid && emailValidation.suggestedDomain) {
            //console.log('Typo detected while typing:', emailValidation.message);
            const suggestedEmail = email.split('@')[0] + '@' + emailValidation.suggestedDomain;
            showErrorMessage(this, emailValidation.message, suggestedEmail);
        } else {
            clearErrorMessage();
        }
    }, 700);

    document.getElementById('k_id_email_footer').addEventListener('input', function () {
        //console.log('Email input event fired');
        debouncedValidateEmail.call(this);
    });

    document
        .getElementById('footer-subscribe-form')
        .addEventListener('submit', function (event) {
            //console.log('Form submission attempted');
            event.preventDefault();
            const emailField = this.querySelector('#k_id_email_footer');
            const emailValue = emailField.value;
            //console.log('Submitted email:', emailValue);
            const emailValidation = validateEmail(emailValue);

            if (!emailValidation.isValid) {
                //console.log('Email validation failed:', emailValidation.message);

                if (emailValidation.suggestedDomain) {
                    const suggestedEmail =
                        emailValue.split('@')[0] + '@' + emailValidation.suggestedDomain;
                    //console.log('Suggesting email:', suggestedEmail);
                    showErrorMessage(emailField, emailValidation.message, suggestedEmail);
                } else {
                    showErrorMessage(emailField, emailValidation.message);
                }

                //console.log('Preventing form submission due to invalid email');
                return;
            }

            clearErrorMessage();

            //console.log('Email is valid, proceeding with form submission');
            var formData = new FormData(event.target);
            var data = Object.fromEntries(formData);

            fetch('https://krw-klav.herokuapp.com/subscribe', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            })
                .then((response) => {
                    if (!response.ok) {
                        return response.json().then(err => { throw err; });
                    }
                    return response.json();
                })
                .then((data) => {
                    if (data.status === 'subscribed') {
                        //console.log('Subscription successful');
                        emailField.value = '';
                        this.classList.add('footer-signup-success');
                        emailField.setAttribute('placeholder', "YOU'RE IN");
                        emailField.blur();
                        clearErrorMessage();
                    } else {
                        throw new Error(data.message || 'Subscription failed');
                    }
                })
                .catch((error) => {
                    console.error('Error subscribing:', error);
                    showErrorMessage(emailField, error.message || 'Error subscribing. Please try again.');
                });
        });

    //console.log('Script fully loaded');
})();